"use strict";
import createDocumentProjection from "./createDocumentProjection.js";
import useDocHandle from "./useDocHandle.js";
export default function useDocument(url, options) {
  const handle = useDocHandle(url, options);
  return [createDocumentProjection(handle), handle];
}
//# sourceMappingURL=useDocument.js.map
